export const SwapMode = {
    ExactIn: 'ExactIn',
    ExactOut: 'ExactOut',
};
Object.setPrototypeOf(SwapMode, null);
